export const ScheduleTypes = {
    GET_ACTIVE_SCHEDULE: "GET_ACTIVE_SCHEDULE",
    CLEAR_ACTIVE_SCHEDULE: "CLEAR_ACTIVE_SCHEDULE",
    GET_PAST_SCHEDULE: "GET_PAST_SCHEDULE",
    CLEAR_PAST_SCHEDULE: "CLEAR_PAST_SCHEDULE",
    GET_ALL_SCHEDULE: "GET_ALL_SCHEDULE",
    CLEAR_ALL_SCHEDULE: "CLEAR_ALL_SCHEDULE",

}